import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-progress',
  templateUrl: './modal-progress.component.html',
})
export class ModalProgressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
